module.exports = __webpack_public_path__ + "static/img/top.71b12ac8.png";